import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import { FDataGridEmptyState } from './FDataGrid.models';

type Props = {
  emptyState?: FDataGridEmptyState;
};

class FDataGridEmptyOverlay extends React.PureComponent<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const emptyState = this.props.emptyState || {};

    return (
      <Box
        sx={{
          height: '100%',
          display: 'grid',
          placeItems: 'center',
          p: 3,
        }}
      >
        <Stack
          spacing={1}
          alignItems="center"
          textAlign="center"
          maxWidth={380}
        >
          <Box sx={{ color: 'text.disabled' }}>
            {emptyState.icon || (
              <InboxOutlinedIcon sx={{ fontSize: 44 }} />
            )}
          </Box>

          <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
            {emptyState.title || 'No records'}
          </Typography>

          <Typography variant="body2" color="text.secondary">
            {emptyState.message || 'There are no rows to display.'}
          </Typography>

          {emptyState.actionLabel && emptyState.onAction && (
            <Button
              size="small"
              variant="contained"
              onClick={emptyState.onAction}
            >
              {emptyState.actionLabel}
            </Button>
          )}
        </Stack>
      </Box>
    );
  }
}

export default FDataGridEmptyOverlay;
